import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import { deleteuploadMedia, getAudio } from "../../services/uploadService";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";

const UploadTable = ({
  data,
  setData,
  pending,
  setLoading,
  totalRows,
  pageNumber,
  setPageNumber,
  setRowsPerPage,
  rowsPerPage,
  manageSortBy,
}) => {
  const [uploadId, setUploadId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const deleteMedia = async () => {
      setLoading(true);
      try {
        const res = await deleteuploadMedia(uploadId);
        if (res?.status === "success") {
          setLoading(false);
          setUploadId(null);
          setData((prevData) =>
            prevData.filter((data) => data.id !== uploadId)
          );
          toast(res.message);
        } else throw new Error("Failed To Delete Transcript");
      } catch (e) {
        setLoading(false);
        setUploadId(null);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (uploadId !== null) deleteMedia();
    // eslint-disable-next-line
  }, [uploadId]);

  const handleSort = (row, sortDirection) => {
    manageSortBy(row.sortField, sortDirection);
  };

  const columns = [
    {
      name: "Upload Date",
      selector: (row) => row.createdAt,
      sortField: "createdAt",
      cell: (row) => {
        return (
          <div
            onClick={() => {
              navigate(`/upload-details?${row.id}`, { state: row });
            }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {moment(row.createdAt).format("dddd MMMM Do")}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Name",
      sortField: "name",
      cell: (row) => {
        return (
          <div
            onClick={() => {
              navigate(`/upload-details?${row.id}`, { state: row });
            }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {JSON.parse(row?.metaData)?.info?.original_filename +
              "." +
              JSON.parse(row?.metaData)?.info?.format}{" "}
            {/* {row.url !== "" && (
              <a
                href={`${row.url}`}
                target="_blank"
                style={{ color: "gray", fontSize: 20 }}
                rel="noreferrer"
              >
                <ion-icon name="attach-outline" />
              </a>
            )} */}
          </div>
        );
      },
      center: true,
      sortable: true,
    },
    {
      name: "Duration",
      cell: (row) => {
        const minutes = Math.floor(
          JSON.parse(row?.metaData)?.info?.duration / 60
        );
        const seconds = Math.floor(
          JSON.parse(row?.metaData)?.info?.duration - minutes * 60
        );
        return minutes + " min  " + seconds + " sec";
      },
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <span
          style={{
            color: "#6e75ff",
            fontWeight: 400,
            fontSize: 15,
            marginLeft: "3%",
          }}
          onClick={() => {
            setUploadId(row.id);
          }}
        >
          <ion-icon name="trash"></ion-icon>
        </span>
      ),
      width: "100px",
      center: true,
      ignoreRowClick: true,
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      <ToastContainer />
      <DataTable
        paginationPerPage={rowsPerPage}
        onChangeRowsPerPage={setRowsPerPage}
        paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
        paginationDefaultPage={pageNumber}
        onChangePage={setPageNumber}
        title="Uploaded Files"
        pagination
        columns={columns}
        data={data}
        pointerOnHover
        highlightOnHover
        progressPending={pending}
        progressComponent={
          <div id="svg-container">
            <RotatingLines
              visible={true}
              height="96"
              width="96"
              color="red"
              strokeColor="grey"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        }
        onRowClicked={(row, event) => {
          navigate(`/upload-details?${row.id}`, { state: row });
        }}
        paginationServer
        paginationServerOptions={{
          persistSelectedOnPageChange: false,
          custom: true,
          totalRows: totalRows,
          totalPages: Math.ceil(totalRows / rowsPerPage),
        }}
        paginationTotalRows={totalRows}
        onSort={handleSort}
        // sortIcon={<span class="sc-kFCroH hkqAST">AA▲</span>}
      />
    </div>
  );
};

export default UploadTable;
